import { AxiosResponse } from 'axios';

import { http } from '@/api/http';
import { IGetParams, IPaginatedListResponse } from '@/api/types';
import { ApiVersion } from '@/config';
import { IBooking } from '@/pages/JMS/Managament/types/booking';

export const BookingApi = {
  create: async (
    data: Pick<IBooking, 'identity' | 'details'>,
  ): Promise<AxiosResponse<IBooking>> => {
    return http.post(`api/${ApiVersion.V1}/bookings`, data);
  },
  get: async (id: string): Promise<AxiosResponse<IBooking>> => {
    return http.get(`api/${ApiVersion.V1}/bookings/${id}`);
  },
  list: async (
    params: IGetParams,
  ): Promise<AxiosResponse<IPaginatedListResponse<IBooking>>> => {
    return http.get(`api/${ApiVersion.V1}/bookings`, { params });
  },
  // booking history records for an inmate
  listByInmate: async (
    inmateId: string,
    params: IGetParams,
  ): Promise<AxiosResponse<IPaginatedListResponse<IBooking>>> => {
    return http.get(`api/${ApiVersion.V1}/bookings/listByInmate/${inmateId}`, {
      params,
    });
  },
  updateIdentity: async (
    data: Pick<IBooking, 'identity'>,
    id?: string,
  ): Promise<AxiosResponse<IBooking>> => {
    return http.patch(`api/${ApiVersion.V1}/bookings/${id}/identity`, data);
  },
  updateDetails: async (
    id: string,
    data: Pick<IBooking, 'details'>,
  ): Promise<AxiosResponse<IBooking>> => {
    return http.patch(`api/${ApiVersion.V1}/bookings/${id}/details`, data);
  },
  updateFingerprints: async (
    id: string,
    data: Pick<IBooking, 'fingerprints'>,
  ): Promise<AxiosResponse<IBooking>> => {
    return http.patch(`api/${ApiVersion.V1}/bookings/${id}/fingerprints`, data);
  },
  deleteFingerprintsFile: async (
    deleteReason: string,
    bookingId: string,
    fileId: string,
  ): Promise<AxiosResponse<IBooking>> => {
    return http.patch(
      `api/${ApiVersion.V1}/bookings/${bookingId}/fingerprints/files/${fileId}`,
      { deleteReason },
    );
  },
  finishBooking: async (id?: string): Promise<AxiosResponse<IBooking>> => {
    return http.patch(`api/${ApiVersion.V1}/bookings/${id}/finish`);
  },
  completeBooking: async (id?: string): Promise<AxiosResponse<IBooking>> => {
    return http.patch(`api/${ApiVersion.V1}/bookings/${id}/complete`);
  },
  updateHousing: async (
    id: string,
    data: Pick<IBooking, 'housing'>,
  ): Promise<AxiosResponse<IBooking>> => {
    return http.patch(`api/${ApiVersion.V1}/bookings/${id}/housing`, data);
  },
  deleteBooking: async (
    id: string,
    deleteReason: string,
  ): Promise<AxiosResponse<IBooking>> => {
    return http.patch(`api/${ApiVersion.V1}/bookings/${id}`, { deleteReason });
  },
};
